import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TwitterService {

  private readonly URL_JS_TWITTER = 'https://platform.twitter.com/widgets.js';

  constructor() {
  }

  public initWidget(){
    const url = this.URL_JS_TWITTER;

    (<any>window).twttr = (function (d, s, id) {
      let js: any, fjs = d.getElementsByTagName(s)[0], t = (<any>window).twttr || {};

      if (d.getElementById(id)) return t;

      js = d.createElement(s);
      js.id = id;
      js.src = url;
      fjs.parentNode.insertBefore(js, fjs);
      t._e = [];

      t.ready = function (f: any) {
        t._e.push(f);
      };

      return t;
    }(document, "script", "twitter-wjs"));

    if ((<any>window).twttr.ready()) (<any>window).twttr.widgets.load();
  }
}
